import { trpc, TrpcInputs } from '../../config/trpc';
import { formatForServer } from '../../utils/format-line-item';

type LineItemInput = TrpcInputs['updateLineItem'];

export const useUpdateLineItem = (id: number) => {
  const { mutateAsync, isLoading, error } = trpc.updateLineItem.useMutation();

  const mutate = (args: LineItemInput) => mutateAsync({ ...formatForServer<LineItemInput>(args), id });

  return [mutate, isLoading, error?.message] as const;
};
